/**
 * Parent Services
 * API calls for parent management
 */

import apiClient, { API_ENDPOINTS } from './AuthService';

const ParentServices = {
  // Get all parents
  getAllParents: async () => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.PARENT.GET_ALL);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Error fetching parents:', error);
      throw error;
    }
  },

  // Get parent by ID
  getParent: async (parentId) => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.PARENT.GET_BY_ID, {
        params: { ParentID: parentId },
      });
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Error fetching parent:', error);
      throw error;
    }
  },

  // Create parent
  createParent: async (parentData) => {
    try {
      const response = await apiClient.post(API_ENDPOINTS.PARENT.ADD, {
        UserID: parentData.UserID,
        Address: parentData.Address,
        ContactNo2: parentData.ContactNo2,
        Role: parentData.Role,
        Status: parentData.Status
      });
      return {
        success: true,
        message: 'Parent created successfully',
        data: response.data,
      };
    } catch (error) {
      console.error('Error creating parent:', error);
      return {
        success: false,
        message: error.message || 'Failed to create parent',
        data: null,
      };
    }
  },

  // Update parent
  updateParent: async (parentId, parentData) => {
    try {
      // Some backends expect the id in payload
      const payload = { ParentID: parentId, ...parentData };
      // API uses POST for update on this backend
      const response = await apiClient.post(API_ENDPOINTS.PARENT.PUT, payload);
      return {
        success: true,
        message: 'Parent updated successfully',
        data: response.data,
      };
    } catch (error) {
      console.error('Error updating parent:', error);
      throw error;
    }
  },

  // Delete parent
  deleteParent: async (parentId) => {
    try {
      // TODO: Replace with actual API call when backend is ready
      // const url = buildURL(API_ENDPOINTS.PARENTS.DELETE, { id: parentId });
      // return await httpClient.delete(url);

      return {
        success: true,
        message: 'Parent deleted successfully',
      };
    } catch (error) {
      console.error('Error deleting parent:', error);
      throw error;
    }
  },

  // Get parent children
  getMyChildren: async (parentId) => {
    try {
      // TODO: Replace with actual API call when backend is ready
      // const url = buildURL(API_ENDPOINTS.PARENTS.CHILDREN, { id: parentId });
      // return await httpClient.get(url);

      return {
        success: true,
        data: [],
      };
    } catch (error) {
      console.error('Error fetching children:', error);
      throw error;
    }
  },

  // Get parent alerts
  getAlerts: async (parentId, filter = {}) => {
    try {
      // TODO: Replace with actual API call when backend is ready
      // const url = buildURL(API_ENDPOINTS.PARENTS.ALERTS, { id: parentId });
      // return await httpClient.get(url, { params: filter });

      return {
        success: true,
        data: [],
      };
    } catch (error) {
      console.error('Error fetching alerts:', error);
      throw error;
    }
  },

  // Get child location (real-time)
  getChildLocation: async (parentId, childId) => {
    try {
      // TODO: Replace with actual API call - preferably WebSocket for real-time
      // const url = buildURL(API_ENDPOINTS.PARENTS.CHILD_LOCATION, { parentId, childId });
      // return await httpClient.get(url);

      return {
        success: true,
        data: {
          childId,
          location: { lat: 28.7041, lng: 77.1025 },
          timestamp: new Date(),
          busId: 1,
          driverName: 'Driver Name',
        },
      };
    } catch (error) {
      console.error('Error fetching child location:', error);
      throw error;
    }
  },

  // Get parent history
  getHistory: async (parentId, filter = {}) => {
    try {
      // TODO: Replace with actual API call when backend is ready
      // const url = buildURL(API_ENDPOINTS.PARENTS.HISTORY, { id: parentId });
      // return await httpClient.get(url, { params: filter });

      return {
        success: true,
        data: [],
      };
    } catch (error) {
      console.error('Error fetching history:', error);
      throw error;
    }
  },

  // Subscribe to child alerts (WebSocket)
  subscribeToAlerts: async (parentId, childId) => {
    try {
      // TODO: Implement WebSocket connection for real-time alerts
      // const wsUrl = `ws://${window.location.host}/api/parents/${parentId}/alerts/${childId}`;
      // const ws = new WebSocket(wsUrl);

      return {
        success: true,
        message: 'Subscribed to alerts',
      };
    } catch (error) {
      console.error('Error subscribing to alerts:', error);
      throw error;
    }
  },

  // Get settings
  getSettings: async (parentId) => {
    try {
      // TODO: Replace with actual API call when backend is ready
      return {
        success: true,
        data: {
          notifications: true,
          dailyReport: true,
          emergencyAlerts: true,
        },
      };
    } catch (error) {
      console.error('Error fetching settings:', error);
      throw error;
    }
  },

  // Update settings
  updateSettings: async (parentId, settings) => {
    try {
      // TODO: Replace with actual API call when backend is ready
      return {
        success: true,
        message: 'Settings updated successfully',
        data: settings,
      };
    } catch (error) {
      console.error('Error updating settings:', error);
      throw error;
    }
  },
};

export default ParentServices;
